import { averageSMG8Aims, belowaverageSMG8Aims } from '../aimTimes';
import { averageSMG9mmParabellumFMJ, belowAverageSMG9mmParabellumFMJ, aboveAverageSMG9mmParabellumFMJ, aboveAverageSMG9mmParabellumJHP, averageSMG45AcpFMJ, averageSMG762TokarevFMJ } from '../projectiles';

export const smgs = Object.freeze({
  'AKS-74U': {
    name: 'AKS-74U',
    list: 'smgs',
    calibre: '5.45 x 39.5mm',
    qty: 1,
    length: '19/29',
    baseWeight: 5,
    rt: 8,
    rof: '*5',
    mag: [{ type: 'Mag', weight: 1.1, cap: 30, qty: 0 }],
    kd: 3,
    sab: 2,
    aim: {
      ac: [1, 2, 3, 4, 5, 6, 7, 8],
      mod: [-21, -11, -8, -6, -5, -4, -3, -2],
    },
    projectiles: [
      {
        type: 'FMJ',
        pen: [8.7, 8.2, 7.5, 6.5, 5.7, 3.6, 2.2, 1.5],
        dc: [4, 3, 3, 3, 3, 2, 2, 1],
      },
      {
        type: 'AP',
        pen: [13, 12, 11, 9.4, 8.2, 5.2, 3.3, 2.1],
        dc: [3, 3, 3, 3, 3, 2, 2, 1],
      },
      {
        type: 'SUB',
        pen: [2.3, 2.1, 2.0, 1.7, 1.5, 0.9, 0.6, 0.4],
        dc: [2, 2, 2, 2, 1, 1, 1, 1],
      },
    ],
    ma: [0.2, 0.3, 0.7, 1, 2, 3, 5, 7],
    ba: [60, 51, 42, 35, 30, 21, 16, 12],
    tof: [0, 0, 1, 2, 3, 6, 9, 13],
    offical: true,
  },
  'Carl Gustaf M45': {
    name: 'Carl Gustaf M45',
    list: 'smgs',
    calibre: '9mm Parabellum',
    qty: 1,
    length: '22/32',
    baseWeight: 7.4,
    rt: 8,
    rof: '*5',
    mag: [{ type: 'Mag', weight: 1.7, cap: 36, qty: 0 }],
    kd: 4,
    sab: 3,
    aim: {
      ac: [1, 2, 3, 4, 5, 6, 7, 8],
      mod: [-23, -13, -9, -7, -6, -4, -3, -2],
    },
    projectiles: [
      {
        type: 'FMJ',
        pen: [2.8, 2.6, 2.2, 1.7, 1.3, 0.5, 0.2, 0.1],
        dc: [4, 4, 3, 3, 2, 2, 1, 1],
      },
      {
        type: 'JHP',
        pen: [2.6, 2.4, 2.0, 1.5, 1.2, 0.5, 0.2, 0.1],
        dc: [6, 6, 5, 4, 3, 2, 1, 1],
      },
    ],
    ma: [0.2, 0.4, 0.8, 1, 2, 4, 6, 8],
    ba: [46, 37, 28, 21, 16, 7, 2, -2],
    tof: [0, 1, 2, 4, 5, 11, 17, 23],
    selector: 'Full Auto Only',
    offical: false,
  },
  F1: {
    name: 'F1',
    list: 'smgs',
    calibre: '9mm Parabellum',
    qty: 1,
    length: '28',
    baseWeight: 7.2,
    rt: 9,
    rof: '*5',
    mag: [{ type: 'Mag', weight: 1.4, cap: 34, qty: 0 }],
    kd: 3,
    sab: 3,
    aim: {
      ac: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      mod: [-23, -12, -9, -8, -6, -5, -4, -3, -3, -2],
    },
    projectiles: [belowAverageSMG9mmParabellumFMJ],
    ma: [0.2, 0.4, 0.8, 1, 2, 4, 6, 8],
    ba: [46, 37, 28, 21, 16, 6, 1, -2],
    tof: [1, 1, 2, 4, 6, 14, 24, 34],
    offical: true,
  },
  'MAC 10 (45 ACP)': {
    name: 'MAC 10 (45 ACP)',
    list: 'smgs',
    calibre: '45 ACP',
    qty: 1,
    length: '11/22',
    baseWeight: 6.2,
    rt: 7,
    rof: '*10',
    mag: [{ type: 'Mag', weight: 2.2, cap: 30, qty: 0 }],
    kd: 5,
    sab: 4,
    aim: averageSMG8Aims,
    projectiles: [
      {
        type: 'FMJ',
        pen: [1.7, 1.6, 1.3, 1.0, 0.8, 0.4, 0.2, 0.1],
        dc: [3, 2, 2, 1, 1, 1, 1, 1],
      },
      {
        type: 'JHP',
        pen: [1.6, 1.5, 1.3, 1.0, 0.8, 0.4, 0.2, 0.1],
        dc: [4, 3, 3, 2, 1, 1, 1, 1],
      },
    ],
    ma: [0.6, 1, 2, 4, 6, 12, 19, 25],
    ba: [45, 37, 28, 21, 16, 6, 1, -3],
    tof: [1, 1, 3, 5, 8, 18, 30, 43],
    offical: true,
  },
  'MAT 49': {
    name: 'MAT 49',
    list: 'smgs',
    calibre: '9mm Parabellum',
    qty: 1,
    length: '18/28',
    baseWeight: 7.7,
    rt: 8,
    rof: '*5',
    mag: [{ type: 'Mag', weight: 1.5, cap: 32, qty: 0 }],
    kd: 3,
    sab: 3,
    aim: {
      ac: [1, 2, 3, 4, 5, 6, 7, 8, 9],
      mod: [-23, -12, -9, -8, -6, -5, -4, -3, -2],
    },
    projectiles: [
      {
        type: 'FMJ',
        pen: [2.4, 2.2, 1.9, 1.5, 1.1, 0.5, 0.2, 0.1],
        dc: [3, 3, 3, 2, 2, 1, 1, 1],
      },
    ],
    ma: [0.2, 0.4, 0.8, 1, 2, 4, 6, 8],
    ba: [46, 37, 28, 21, 16, 7, 1, -2],
    tof: [0, 1, 2, 4, 6, 13, 22, 32],
    selector: 'Full Auto Only',
    offical: true,
  },
  'Owen Mk1': {
    name: 'Owen Mk1',
    list: 'smgs',
    calibre: '9mm Parabellum',
    qty: 1,
    length: '32',
    baseWeight: 8.7,
    rt: 9,
    rof: '*6',
    mag: [{ type: 'Mag', weight: 1.4, cap: 34, qty: 0 }],
    kd: 3,
    sab: 2,
    aim: {
      ac: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
      mod: [-23, -13, -10, -8, -7, -5, -4, -4, -3, -2, -1],
    },
    projectiles: [averageSMG9mmParabellumFMJ],
    ma: [0.2, 0.5, 0.9, 2, 2, 5, 7, 9],
    ba: [45, 36, 27, 20, 15, 6, 0, -3],
    tof: [0, 1, 2, 4, 6, 13, 23, 32],
    offical: true,
  },
  M3A1: {
    name: 'M3A1',
    list: 'smgs',
    calibre: '45 ACP',
    qty: 1,
    length: '23/30',
    baseWeight: 7.4,
    rt: 8,
    rof: '*4',
    mag: [{ type: 'Mag', weight: 2.0, cap: 30, qty: 0 }],
    kd: 5,
    sab: 3,
    aim: belowaverageSMG8Aims,
    projectiles: [averageSMG45AcpFMJ],
    ma: [0.2, 0.5, 0.9, 2, 2, 5, 9, 12],
    ba: [45, 36, 27, 20, 15, 5, 0, -4],
    tof: [1, 1, 3, 5, 8, 18, 30, 44],
    selector: 'Full Auto Only',
    offical: true,
  },
  MP5: {
    name: 'MP5',
    list: 'smgs',
    calibre: '9mm Parabellum',
    qty: 1,
    length: '19/27',
    baseWeight: 5.6,
    rt: 8,
    rof: '*7',
    mag: [{ type: 'Mag', weight: 1.2, cap: 30, qty: 0 }],
    kd: 4,
    sab: 3,
    aim: {
      ac: [1, 2, 3, 4, 5, 6, 7, 8, 9],
      mod: [-20, -10, -8, -6, -5, -4, -3, -2, -1],
    },
    projectiles: [
      aboveAverageSMG9mmParabellumFMJ,
      aboveAverageSMG9mmParabellumJHP,
    ],
    ma: [0.4, 0.7, 1, 2, 4, 7, 11, 14],
    ba: [46, 37, 28, 21, 16, 7, 2, -2],
    tof: [0, 1, 2, 4, 6, 13, 21, 31],
    offical: true,
  },
  MP5K: {
    name: 'MP5K',
    list: 'smgs',
    calibre: '9mm Parabellum',
    qty: 1,
    length: '13',
    baseWeight: 4.4,
    rt: 7,
    rof: '**8',
    mag: [{ type: 'Mag', weight: 1.2, cap: 30, qty: 0 }],
    kd: 3,
    sab: 3,
    aim: {
      ac: [1, 2, 3, 4, 5, 6, 7],
      mod: [-19, -11, -10, -9, -8, -7, -6],
    },
    projectiles: [
      {
        type: 'FMJ',
        pen: [2.2, 2, 1.7, 1.3, 1, 0.4, 0.2, 0.1],
        dc: [3, 3, 2, 2, 1, 1, 1, 1],
      },
      {
        type: 'JHP',
        pen: [2.1, 2, 1.6, 1.3, 1, 0.4, 0.2, 0.1],
        dc: [5, 4, 4, 3, 2, 1, 1, 1],
      },
    ],
    trb: [-6, -1, 4, 8, 11, 16, 19, 21],
    ma: [0.4, 0.8, 2, 3, 4, 8, 12, 17],
    ba: [46, 37, 28, 21, 16, 6, 1, -2],
    tof: [0, 1, 2, 4, 6, 14, 23, 33],
    offical: true,
  },
  'MP5 SD3': {
    name: 'MP5 SD3',
    list: 'smgs',
    calibre: '9mm Parabellum',
    qty: 1,
    length: '27/32',
    baseWeight: 7.5,
    rt: 8,
    rof: '*7',
    mag: [{ type: 'Mag', weight: 1.2, cap: 30, qty: 0 }],
    kd: 3,
    sab: 2,
    aim: {
      ac: [1, 2, 3, 4, 5, 6, 7, 8, 9],
      mod: [-22, -12, -9, -6, -5, -4, -3, -2, -1],
    },
    projectiles: [
      {
        type: 'FMJ',
        pen: [1.4, 1.3, 1.1, 0.9, 0.7, 0.3, 0.1, ''],
        dc: [2, 2, 2, 2, 2, 1, 1, ''],
      },
      {
        type: 'JHP',
        pen: [1.3, 1.2, 1.0, 0.8, 0.6, 0.2, 0.1, ''],
        dc: [3, 3, 3, 2, 2, 1, 1, ''],
      },
    ],
    ma: [0.4, 0.7, 1, 2, 4, 7, 11, ''],
    ba: [46, 37, 28, 21, 16, 7, 2, ''],
    tof: [0, 1, 3, 6, 8, 17, 26, ''],
    offical: false,
  },
  'PPSh 41': {
    name: 'PPSh 41',
    list: 'smgs',
    calibre: '7.62mm Tokarev',
    qty: 1,
    length: '33',
    baseWeight: 7.3,
    rt: 12,
    rof: '*8',
    mag: [{ type: 'Drm', weight: 2.4, cap: 71, qty: 0 }],
    kd: 3,
    sab: 2,
    aim: {
      ac: [1, 2, 3, 4, 5, 6, 7, 8, 9],
      mod: [-23, -13, -9, -8, -6, -5, -4, -3, -2],
    },
    projectiles: [averageSMG762TokarevFMJ],
    ma: [0.3, 0.6, 1, 2, 3, 6, 9, 12],
    ba: [47, 39, 30, 22, 18, 8, 3, -1],
    tof: [0, 1, 2, 3, 4, 10, 17, 25],
    offical: true,
  },
  'PPS 43': {
    name: 'PPS 43',
    list: 'smgs',
    calibre: '7.62mm Tokarev',
    qty: 1,
    length: '33',
    baseWeight: 6.5,
    rt: 8,
    rof: '*6',
    mag: [{ type: 'Mag', weight: 1.2, cap: 35, qty: 0 }],
    kd: 3,
    sab: 3,
    aim: {
      ac: [1, 2, 3, 4, 5, 6, 7, 8, 9],
      mod: [-22, -12, -9, -7, -6, -5, -4, -3, -2],
    },
    projectiles: [averageSMG762TokarevFMJ],
    ma: [0.3, 0.5, 1, 2, 3, 5, 8, 11],
    ba: [47, 39, 30, 23, 18, 8, 3, -1],
    tof: [0, 1, 2, 3, 4, 10, 17, 24],
    selector: 'Full Auto Only',
    offical: true,
  },
  'Sten Mk2': {
    name: 'Sten Mk2',
    list: 'smgs',
    calibre: '9mm Parabellum',
    qty: 1,
    length: '30',
    baseWeight: 5.9,
    rt: 9,
    rof: '*5',
    mag: [{ type: 'Mag', weight: 1.3, cap: 32, qty: 0 }],
    kd: 3,
    sab: 3,
    aim: averageSMG8Aims,
    projectiles: [averageSMG9mmParabellumFMJ],
    ma: [0.2, 0.5, 0.9, 2, 2, 5, 7, 9],
    ba: [45, 36, 27, 20, 15, 6, 0, -3],
    tof: [0, 1, 2, 4, 6, 13, 23, 32],
    offical: true,
  },
  'Thompson M1A1': {
    name: 'Thompson M1A1',
    list: 'smgs',
    calibre: '45 ACP',
    qty: 1,
    length: '32',
    baseWeight: 10,
    rt: 8,
    rof: '*6',
    mag: [{ type: 'Mag', weight: 2.0, cap: 30, qty: 0 }],
    kd: 5,
    sab: 3,
    aim: {
      ac: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
      mod: [-24, -14, -10, -8, -7, -6, -5, -4, -3, -2, -1],
    },
    projectiles: [averageSMG45AcpFMJ],
    ma: [0.3, 0.6, 1, 2, 3, 6, 9, 12],
    ba: [45, 36, 27, 20, 15, 5, 0, -4],
    tof: [1, 1, 3, 5, 8, 18, 30, 44],
    selector: 'Full Auto Only',
    offical: true,
  },
  Uzi: {
    name: 'Uzi',
    list: 'smgs',
    calibre: '9mm Parabellum',
    qty: 1,
    length: '19/26',
    baseWeight: 7.7,
    rt: 8,
    rof: '*5',
    mag: [{ type: 'Mag', weight: 1.3, cap: 32, qty: 0 }],
    kd: 4,
    sab: 3,
    aim: belowaverageSMG8Aims,
    projectiles: [
      aboveAverageSMG9mmParabellumFMJ,
      aboveAverageSMG9mmParabellumJHP,
    ],
    ma: [0.2, 0.4, 0.9, 1, 2, 4, 6, 9],
    ba: [46, 37, 28, 21, 16, 7, 1, -2],
    tof: [0, 1, 2, 4, 6, 13, 21, 31],
    offical: true,
  },
  'Mini Uzi': {
    name: 'Mini Uzi',
    list: 'smgs',
    calibre: '9mm Parabellum',
    qty: 1,
    length: '14/24',
    baseWeight: 6,
    rt: 7,
    rof: '*8',
    mag: [{ type: 'Mag', weight: 1.3, cap: 32, qty: 0 }],
    kd: 3,
    sab: 3,
    aim: averageSMG8Aims,
    projectiles: [
      {
        type: 'FMJ',
        pen: [1.9, 1.8, 1.5, 1.1, 0.9, 0.4, 0.1, 0.1],
        dc: [3, 3, 2, 2, 1, 1, 1, 1],
      },
      {
        type: 'JHP',
        pen: [1.9, 1.7, 1.4, 1.1, 0.8, 0.3, 0.1, 0.1],
        dc: [4, 4, 3, 2, 1, 1, 1, 1],
      },
    ],
    ma: [0.3, 0.7, 1, 2, 3, 7, 10, 13],
    ba: [45, 37, 28, 21, 16, 6, 1, -2],
    tof: [1, 1, 2, 4, 6, 15, 25, 36],
    offical: true,
  },
});
